<app-doc-viewer
  title="Hover"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/hover">
    <igo-map-browser
      [map]="map"
      [view]="view"
      igoHoverFeature
      [igoHoverFeatureDelay]="pointerHoverFeatureDelay"
      [igoHoverFeatureEnabled]="true"
    >
      <div class="map-actions --vertical --top --right">
        <div class="spinner-spacer"></div>
        <igo-rotation-button
          class="mat-elevation-z2"
          [showIfNoRotation]="true"
          [map]="map"
          color="primary"
        />
      </div>
      <div class="map-actions --vertical --bottom --right">
        <igo-home-extent-button
          class="mat-elevation-z2"
          [map]="map"
          color="primary"
        />
        <igo-geolocate-button
          class="mat-elevation-z2"
          [map]="map"
          color="primary"
        />
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>
  </app-example-viewer>
</app-doc-viewer>
